(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"4f3832f9cc96852a60247b9c56af5d73e79e5fff"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = FTkx
// module chunks = 1